<template>
  <div>
    <div class="section">
      <el-form
        label-position="left"
        label-width="90px"
      >
        <div class="el-form-item-wrapper" style="display: flex">
          <el-form-item :label="$t('CargoMsg.Cargo_PlatformEnterpriseName')">
            <el-input v-model="params.enterpriseName" style="width: 150px;padding-left: 10px" clearable />
          </el-form-item>
          <div style="padding-left: 10px">
            <el-button type="primary" @click="initEnterpriseInterfaceConfig">
              {{ $t('CargoMsg.Cargo_Query') }}
            </el-button>
            <el-button type="primary" @click="addHandler">
              {{ $t('CargoMsg.Cargo_Add') }}
            </el-button>
            <!--            <el-button type="primary" @click="onCopy">-->
            <!--              {{ $t('SeaExport.OperationLog') }}-->
            <!--            </el-button>-->
            <el-button type="primary" @click="statisticsHandle">
              {{ $t('CargoMsg.Cargo_Statistics') }}
            </el-button>
          </div>
        </div>
      </el-form>
    </div>
    <div class="grid-view">
      <div class="main-content">
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="261603"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
      </div>
    </div>
    <!--编辑弹窗-->
    <el-dialog
      v-if="editDialog.visible"
      :visible.sync="editDialog.visible"
      :title="$t('CargoMsg.Cargo_PlatformEnterpriseInterfaceConfiguration')"
      width="580px"
      height="580px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form label-position="right" label-width="120px">
        <el-row>
          <el-col :span="17">
            <el-form-item :label="$t('CargoMsg.Cargo_PlatformEnterpriseName')" required>
              <el-input v-model="editDialog.form.enterpriseName" :disabled="!!editDialog.form.uuid" no="1" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="17">
            <el-form-item :label="$t('CargoMsg.Cargo_AccessKey')" required>
              <span no="2">{{ editDialog.form.accessKey }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="17">
            <el-form-item :label="$t('CargoMsg.Cargo_SecretKey')" required>
              <span no="3">{{ editDialog.form.secretKey }}</span>
              <el-button :disabled="!!editDialog.form.uuid" type="primary" style="margin-left: 10px" @click="generateSecretKey">{{ $t('CargoMsg.Cargo_AutomaticGenerated') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="17">
            <el-form-item :label="$t('CargoMsg.Cargo_EffectiveDate')">
              <el-date-picker
                v-model="editDialog.form.beginDate"
                no="EffectiveDate"
                type="date"
                style="width: 100%"
                :placeholder="$t('CargoMsg.Cargo_Select')+$t('CargoMsg.Cargo_EffectiveDate')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="17">
            <el-form-item :label="$t('CargoMsg.Cargo_InvalidDate')">
              <el-date-picker
                v-model="editDialog.form.endDate"
                no="InvalidDate"
                type="date"
                style="width: 100%"
                :placeholder="$t('CargoMsg.Cargo_Select')+$t('CargoMsg.Cargo_InvalidDate')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="17">
            <el-form-item :label="$t('CargoMsg.Cargo_CallBackUrl')">
              <el-input v-model="editDialog.form.callBackUrl" :disabled="!!editDialog.form.uuid" no="4" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="saveEnterpriseInterfaceConfig">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!--统计弹窗-->
    <el-dialog
      v-if="statisticsDialog.visible"
      :visible.sync="statisticsDialog.visible"
      :title="$t('CargoMsg.Cargo_UsageStatistics')"
      width="935px"
      height="600px"
      :close-on-click-modal="false"
      append-to-body
    >
      <cargo-ag-grid
        config-module="261604"
        :grid-options="statisticsDialog.gridOptions"
        :column-defs="statisticsDialog.columnDefs"
        :row-data="statisticsDialog.rowData"
        :style="{width:'100%',height:'600px'}"
        no="1"
      />
      <!--      <span slot="footer">-->
      <!--        <el-button @click="statisticsDialog.visible=false">{{ $t('common.btn.back') }}</el-button>-->
      <!--      </span>-->
    </el-dialog>
    <!--统计详情弹窗-->
    <el-dialog
      v-if="statisticsDetailDialog.visible"
      :visible.sync="statisticsDetailDialog.visible"
      :title="$t('CargoMsg.Cargo_UsingFlowingWater')"
      width="845px"
      height="500px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div style="padding: 10px">
        <span> {{ $t('CargoMsg.Cargo_PlatformEnterpriseName') + '：' + statisticsDetailDialog.selectedData.enterpriseName }} </span>
        <span style="margin-left: 30px"> {{ $t('CargoMsg.Cargo_CallTemplateId') + '：' + statisticsDetailDialog.selectedData.templateUuid }} </span>
      </div>
      <cargo-ag-grid
        config-module="261605"
        :grid-options="statisticsDetailDialog.gridOptions"
        :column-defs="statisticsDetailDialog.columnDefs"
        :row-data="statisticsDetailDialog.rowData"
        :style="{width:'100%',height:'500px'}"
        no="1"
      />
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="statisticsDetailDialog.total>0"
          config-module="261605"
          :total="statisticsDetailDialog.total"
          :page.sync="statisticsDetailDialog.pageNum"
          :limit.sync="statisticsDetailDialog.pageSize"
          @pagination="statisticsDetailHandle()"
        />
      </div>
      <!--      <span slot="footer">-->
      <!--        <el-button @click="statisticsDetailDialog.visible=false">{{ $t('common.btn.back') }}</el-button>-->
      <!--      </span>-->
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import OperationRender from '@/components/OperationRender'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getStatisticsDetail, getStatisticsList } from '@/api/ocrTemplate'
import OcrTemplateConfigDetail from '@/views/cargo/v0/SystemMaintenance/components/ocr/ocrTemplateConfigDetail'
import {
  OCR_ENTERPRISE_STATUS_INVALID, OCR_ENTERPRISE_STATUS_VALID,
  OCR_ENTERPRISE_STATUS_WITH_DATE_INVALID,
  OCR_ENTERPRISE_STATUS_WITH_DATE_NOT_EFFECTIVE,
  OCR_ENTERPRISE_STATUS_WITH_DATE_VALID
} from '@/class/cargo/model/parameters/SystemConstants'
import {
  activeEnterpriseInterfaceConfig,
  getEnterpriseInterfaceConfigAccessKey,
  getEnterpriseInterfaceConfigList,
  getEnterpriseInterfaceConfigSecretKey, saveEnterpriseInterfaceConfig
} from '@/api/enterpriseInterfaceConfig'
import { deepCopy } from '@/utils/commonUtil'
import DateUtils from '@/utils/dateUtils'

export default {
  name: 'EnterpriseInterfaceConfig',
  components: { OcrTemplateConfigDetail },
  data() {
    return {
      gridApi: null,
      showDetail: false,
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onRowClicked: event => { this.currentEnterpriseInterfaceConfig = event.data }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_PlatformEnterpriseName'),
          field: 'enterpriseName'
        }, {
          headerName: this.$t('CargoMsg.Cargo_AccessKey'),
          field: 'accessKey'
        }, {
          headerName: this.$t('CargoMsg.Cargo_SecretKey'),
          field: 'secretKey'
        }, {
          headerName: this.$t('CargoMsg.Cargo_EffectiveDate'),
          field: 'beginDate',
          colId: 'beginDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_InvalidDate'),
          field: 'endDate',
          colId: 'endDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CallBackUrl'),
          field: 'callBackUrl'
        }, {
          headerName: this.$t('CargoMsg.Cargo_Status'),
          field: 'statusWithDate',
          cellRenderer: (params) => {
            return ColumnUtils.ocrEnterpriseStatusWithDateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_OperateBy'), field: 'modifiedBy', colId: 'modifiedBy', width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_OperateTime'), field: 'dateModified', colId: 'dateModified', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: '',
          colId: '',
          width: 200,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('CargoMsg.Cargo_Edit'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.editHandler(params)
                },
                visible: () => true
              }, {
                title: this.$t('CargoMsg.Cargo_Disable'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;color: #f57174',
                onClick: (params) => {
                  this.disableHandler(params)
                },
                visible: (params) => OCR_ENTERPRISE_STATUS_WITH_DATE_VALID.code === params.statusWithDate || OCR_ENTERPRISE_STATUS_WITH_DATE_NOT_EFFECTIVE.code === params.statusWithDate
              }, {
                title: this.$t('CargoMsg.Cargo_Enable'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.enableHandler(params)
                },
                visible: (params) => OCR_ENTERPRISE_STATUS_WITH_DATE_INVALID.code === params.statusWithDate
              }
            ]
          }
        }
      ],
      rowData: [],
      params: { templateName: null },
      currentEnterpriseInterfaceConfig: null,
      loading: null,
      editDialog: {
        visible: false,
        form: {}
      },
      statisticsDialog: {
        visible: false,
        rowData: [],
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          { headerName: this.$t('CargoMsg.Cargo_PlatformEnterpriseName'), field: 'enterpriseName', width: 200 },
          {
            headerName: this.$t('CargoMsg.Cargo_TemplateId'), field: 'templateUuid', width: 200
          },
          { headerName: this.$t('Template.TemplateName'), field: 'templateName', width: 200 },
          { headerName: this.$t('CargoMsg.Cargo_NumberOfSuccessfulCalls'), field: 'successCount', width: 140 },
          {
            headerName: this.$t('CargoMsg.Cargo_Details'),
            field: '',
            minWidth: 150,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: OperationRender,
            cellRendererParams: {
              operations: [
                {
                  title: this.$t('CargoMsg.Cargo_QueryFlowingWater'),
                  type: 'primary',
                  cssStyle: 'text-decoration: underline;',
                  onClick: (params) => {
                    this.statisticsDetailHandle(params)
                  },
                  visible: () => true
                }
              ]
            }
          }
        ]
      },
      statisticsDetailDialog: {
        visible: false,
        rowData: [],
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          { headerName: this.$t('CargoMsg.Cargo_TimeOfUse'), field: 'dateCreated', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateMinutesLabelFunc(params.value)
            } },
          {
            headerName: this.$t('CargoMsg.Cargo_CallResult'), field: 'status', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.ocrTemplateCallStatusLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_InputTokenCount'), field: 'inputTokenCount', width: 200
          },
          {
            headerName: this.$t('CargoMsg.Cargo_OutputTokenCount'), field: 'outputTokenCount', width: 200
          }
        ],
        selectedData: null,
        pageNum: 1,
        pageSize: 20
      }
    }
  },
  created() {
    this.initEnterpriseInterfaceConfig()
  },
  methods: {
    initEnterpriseInterfaceConfig() {
      this.loading = getLoading4Cxt()
      // 查询
      getEnterpriseInterfaceConfigList(this.params).then(res => {
        this.rowData = res.data || []
      }).finally(() => {
        this.loading.close()
      })
    },
    addHandler() {
      this.loading = getLoading4Cxt()
      // 生成 accessKey
      getEnterpriseInterfaceConfigAccessKey(this.params).then(res => {
        this.editDialog.form = { accessKey: res.data }
        this.editDialog.visible = true
      }).finally(() => {
        this.loading.close()
      })
    },
    editHandler(params) {
      this.editDialog.form = deepCopy(params)
      this.editDialog.visible = true
    },
    disableHandler(params) {
      this.$confirm(this.$t('CargoMsg.Cargo_InValidThisRecognitionEnterprise'), this.$t('CargoMsg.Cargo_Tips'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        params.active = OCR_ENTERPRISE_STATUS_INVALID.code
        this.loading = getLoading4Cxt()
        activeEnterpriseInterfaceConfig(params).then(res => {
          params.statusWithDate = res.data
          this.gridApi.refreshCells({ force: true })
          this.$message.success(this.$t('common.tips.saveSuccess'))
        }).finally(() => {
          this.loading.close()
        })
      }).catch(() => {
        //
      })
    },
    enableHandler(params) {
      if ((params.endDate && new Date(params.endDate) < new Date()) || (params.startDate && new Date(params.startDate) > new Date())) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CannotEnable'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_ValidThisRecognitionEnterprise'), this.$t('CargoMsg.Cargo_Tips'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        params.active = OCR_ENTERPRISE_STATUS_VALID.code
        this.loading = getLoading4Cxt()
        activeEnterpriseInterfaceConfig(params).then(res => {
          params.statusWithDate = res.data
          this.gridApi.refreshCells({ force: true })
          this.$message.success(this.$t('common.tips.saveSuccess'))
        }).finally(() => {
          this.loading.close()
        })
      }).catch(() => {
        //
      })
    },
    // 生成 secretKey
    generateSecretKey() {
      this.loading = getLoading4Cxt()
      // 生成 accessKey
      getEnterpriseInterfaceConfigSecretKey(this.params).then(res => {
        this.editDialog.form.secretKey = res.data
        this.$forceUpdate()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 保存
    saveEnterpriseInterfaceConfig() {
      if (!this.editDialog.form.enterpriseName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_PlatformEnterpriseName'))
        return
      }
      if (!this.editDialog.form.secretKey) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsGenerate') + this.$t('CargoMsg.Cargo_SecretKey'))
        return
      }
      if (this.editDialog.form.beginDate && this.editDialog.form.endDate) {
        if (new Date(this.editDialog.form.beginDate) > new Date(this.editDialog.form.endDate)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_DateErrorTip'))
          return
        }
      }
      if (this.editDialog.form.beginDate) {
        this.editDialog.form.beginDate = DateUtils.formatStandardDate(new Date(this.editDialog.form.beginDate), 'YYYY-MM-DD') + ' 00:00:00'
      }
      if (this.editDialog.form.endDate) {
        this.editDialog.form.endDate = DateUtils.formatStandardDate(new Date(this.editDialog.form.endDate), 'YYYY-MM-DD') + ' 23:59:59'
      }
      this.loading = getLoading4Cxt()
      saveEnterpriseInterfaceConfig(this.editDialog.form).then(res => {
        this.$message.success(this.$t('common.tips.saveSuccess'))
        this.editDialog.visible = false
        this.initEnterpriseInterfaceConfig()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 统计列表
    statisticsHandle() {
      let params = {}
      if (this.currentEnterpriseInterfaceConfig) {
        params = { enterpriseUuid: this.currentEnterpriseInterfaceConfig.uuid }
      }
      this.loading = getLoading4Cxt()
      getStatisticsList(params).then(res => {
        this.statisticsDialog.rowData = res.data
        this.statisticsDialog.visible = true
      }).finally(() => {
        this.loading.close()
      })
    },
    // 统计详情
    statisticsDetailHandle(params) {
      if (params) {
        this.statisticsDetailDialog.selectedData = params
        this.statisticsDetailDialog.pageNum = 1
        this.statisticsDetailDialog.pageSize = 20
      }
      this.loading = getLoading4Cxt()
      getStatisticsDetail({
        enterpriseUuid: this.statisticsDetailDialog.selectedData.enterpriseUuid,
        templateUuid: this.statisticsDetailDialog.selectedData.templateUuid,
        pageNum: this.statisticsDetailDialog.pageNum,
        pageSize: this.statisticsDetailDialog.pageSize
      }).then(res => {
        this.statisticsDetailDialog.rowData = res.data.list
        this.statisticsDetailDialog.pageNum = res.data.pageNum
        this.statisticsDetailDialog.pageSize = res.data.pageSize
        this.statisticsDetailDialog.total = Number(res.data.total)
        this.statisticsDetailDialog.visible = true
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>
